// Cache per wizardActiveItem object (auto-GC when wizard item is replaced)
const WIZARD_INDEX_CACHE = new WeakMap();

export const buildWizardIndex = (wizardActiveItem) => {
  const groupById = new Map();
  const groups = wizardActiveItem.wizardGroups || [];
  for (const g of groups) groupById.set(g.id, g);

  // source(string) -> Set(targetId)
  const edgesBySource = new Map();
  const edges = wizardActiveItem.wizardEdges || [];
  for (const e of edges) {
    const src = String(e.source);
    let set = edgesBySource.get(src);
    if (!set) {
      set = new Set();
      edgesBySource.set(src, set);
    }
    set.add(e.target);
  }

  return { groups, groupById, edgesBySource };
};

export const getWizardIndex = (wizardActiveItem) => {
  if (!wizardActiveItem) return null;
  let idx = WIZARD_INDEX_CACHE.get(wizardActiveItem);
  if (!idx) {
    idx = buildWizardIndex(wizardActiveItem);
    WIZARD_INDEX_CACHE.set(wizardActiveItem, idx);
  }
  return idx;
};
